import React, { useMemo, useState } from "react";
import { Snackbar as MUISnackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const defaultPosition = {
    vertical: "bottom",
    horizontal: "center",
};

export const useSnackbar = ({ duration, severity, position = defaultPosition }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = (e, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setIsOpen(false);
    };

    const Snackbar = useMemo(() => {
        return ({ children }) => (
            <MUISnackbar
                open={isOpen}
                onClose={handleClose}
                autoHideDuration={duration}
                anchorOrigin={position}
            >
                <Alert severity={severity}>{children}</Alert>
            </MUISnackbar>
        );
    }, [isOpen]);

    return {
        Snackbar,
        isSnackbarOpen: isOpen,
        setIsSnackbarOpen: setIsOpen,
        toggleSnackbar: () => setIsOpen(!isOpen),
    };
};
